import { connect } from 'react-redux';
import AggregateRow from '../components/aggregate_row';
import { toggleMemberFavorite } from '../actions/member_search_index';
import { fetchDetails, removeDetails } from '../actions/details_index';
import { selectIsManagerSite, selectDisplayedFlags, selectStateFlagUrls, selectVisibleColumns } from '../selectors'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../utils/empty'
import { detailsKeyFor } from '../utils/details_utils'

const mapStateToProps = (state, ownProps) => {
  const eventId = String(ownProps.eventId);
  const eventState = state.event?.[eventId];
  const memberId = ownProps.agg?.memberIds?.[0]

  return {
    rounds: eventState?.data?.rounds ?? EMPTY_OBJECT,
    columns: selectVisibleColumns(state, eventId),
    // A boolean, not the array: connect shallow-compares, so starring one
    // player re-renders that row instead of every row in the table.
    isFavorite: !!memberId && (eventState?.favorites ?? EMPTY_ARRAY).includes(memberId),
    // A boolean for the same reason: the event's details map is replaced on
    // every scorecard fetch, close and poll refresh, so passing the map would
    // re-render every row of the event while any one scorecard is open.
    isDetailsOpen: !!ownProps.agg && !!state.details[eventId]?.[detailsKeyFor(ownProps.agg.memberIds)],
    colorScores: state.leaderboardV2.colorScores,
    displayedFlags: selectDisplayedFlags(state, eventId),
    stateFlagUrls: selectStateFlagUrls(state),
    isManagerSite: selectIsManagerSite(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  // The row star favorites the member in every event they played (and
  // removes them everywhere on unstar), same as the member-search star.
  // The clicked eventId makes the add optimistic: that event's star and
  // favorites table update synchronously while the played-events fan-out
  // resolves the rest in the background.
  toggleFavorite: (eventId, memberId) => dispatch(toggleMemberFavorite(memberId, eventId)),
  fetchDetails: (eventId, aggId, detailsKey) => dispatch(fetchDetails(eventId, aggId, detailsKey)),
  removeDetails: (eventId, detailsKey) => dispatch(removeDetails(eventId, detailsKey)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AggregateRow);
